<div class="hp">
    <button type="button" class="hp-icon-btn hp-corner-close" aria-label="Close" (click)="close()">
        <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M18 6 6 18M6 6l12 12"></path>
        </svg>
    </button>

    <!-- home -->
    <ng-container *ngIf="view === 'home'">
        <div class="hp-home">
            <div class="hp-heading">How can we help?</div>
            <div class="hp-options">
                <button type="button" class="hp-option" (click)="goAsk()">
                    <span class="hp-option__icon"
                        ><svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path></svg
                    ></span>
                    <span class="hp-option__copy"
                        ><span class="hp-option__title">Ask a question</span
                        ><span class="hp-option__sub"
                            >Ask about your setup, Microsoft 365, or anything Trovve.</span
                        ></span
                    >
                    <svg
                        class="hp-option__chev"
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#9ca3af"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="m9 18 6-6-6-6"></path>
                    </svg>
                </button>
                <button type="button" class="hp-option" (click)="goSetup()">
                    <span class="hp-option__icon"
                        ><svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path
                                d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                            ></path></svg
                    ></span>
                    <span class="hp-option__copy"
                        ><span class="hp-option__title">Get setup help</span
                        ><span class="hp-option__sub">We can help configure Trovve with you.</span></span
                    >
                    <svg
                        class="hp-option__chev"
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#9ca3af"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="m9 18 6-6-6-6"></path>
                    </svg>
                </button>
            </div>
        </div>
        <div class="hp-person hp-home-foot">
            <img
                src="assets/images/trovve-team-avatar.png"
                alt="Trovve team member"
                width="32"
                height="32"
                class="hp-avatar"
            />
            <span class="hp-person__text"
                >A real person from Trovve will reply by email, usually within one business day.</span
            >
        </div>
    </ng-container>

    <!-- ask -->
    <div class="hp-view" *ngIf="view === 'ask'">
        <button type="button" class="hp-icon-btn hp-back" aria-label="Back to How can we help?" (click)="goHome()">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M19 12H5M12 19l-7-7 7-7"></path>
            </svg>
        </button>
        <div class="hp-title">Ask Trovve</div>
        <label class="hp-label" for="vf-hp-question">What would you like to know?</label>
        <textarea
            id="vf-hp-question"
            #questionBox
            class="hp-textarea"
            rows="2"
            placeholder="Ask anything about Trovve..."
            [value]="question"
            (input)="onQuestionInput($any($event.target).value)"
        ></textarea>
        <div class="hp-eyebrow">Common questions</div>
        <div class="hp-chips">
            <button
                type="button"
                class="hp-chip"
                *ngFor="let item of quickQuestions; trackBy: trackByQuestion"
                (click)="pickQuestion(item)"
            >
                {{ item.label }}
            </button>
            <button type="button" class="hp-more" *ngIf="!showAllQuestions" (click)="showMoreQuestions()">
                More questions
            </button>
        </div>
        <div class="hp-foot">
            <div class="hp-person">
                <img
                    src="assets/images/trovve-team-avatar.png"
                    alt="Trovve team member"
                    width="32"
                    height="32"
                    class="hp-avatar"
                />
                <span class="hp-person__text"
                    >A real person from Trovve will reply by email, usually within one business day.</span
                >
            </div>
            <button
                type="button"
                class="hp-send"
                [class.hp-send--on]="!sendDisabled"
                [disabled]="sendDisabled"
                (click)="sendQuestion()"
            >
                Send question
            </button>
        </div>
    </div>

    <!-- setup -->
    <div class="hp-view" *ngIf="view === 'setup'">
        <button type="button" class="hp-icon-btn hp-back" aria-label="Back to How can we help?" (click)="goHome()">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M19 12H5M12 19l-7-7 7-7"></path>
            </svg>
        </button>
        <div class="hp-title">Want help getting Trovve set up?</div>
        <div class="hp-lead">A Trovve team member can help with:</div>
        <ul class="hp-list">
            <li>Clients</li>
            <li>Templates</li>
            <li>Email rules</li>
            <li>Microsoft 365 setup</li>
            <li>Training</li>
        </ul>
        <div class="hp-foot">
            <div class="hp-person">
                <img
                    src="assets/images/trovve-team-avatar.png"
                    alt="Trovve team member"
                    width="32"
                    height="32"
                    class="hp-avatar"
                />
                <span class="hp-person__text"
                    >A real person from Trovve will follow up with you, usually within one business day.</span
                >
            </div>
            <button type="button" class="hp-btn-dark" (click)="requestSetupHelp()">Request setup help</button>
        </div>
    </div>

    <!-- sent: after a question draft opens the banner moves into Get help after 2 s (GetHelpStateService.questionSent); setup help waits for Done -->
    <div class="hp-view hp-sent" *ngIf="view === 'sent'" role="status">
        <span class="hp-sent__badge">
            <img
                src="assets/images/trovve-team-avatar.png"
                alt="Trovve team member"
                width="44"
                height="44"
                class="hp-avatar hp-avatar--lg"
            />
            <span class="hp-sent__check"
                ><svg
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    stroke-width="3.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M20 6 9 17l-5-5"></path></svg
            ></span>
        </span>
        <div class="hp-sent__title">Email draft opened</div>
        <div class="hp-sent__text">{{ sentText }}</div>
        <button type="button" class="hp-btn-light" *ngIf="sentKind === 'setup'" (click)="close()">Done</button>
    </div>
</div>
